// extracted by mini-css-extract-plugin
export default {"lightbox":"image_lightbox__XlukI","show":"image_show__DEKuo","show_image":"image_show_image__rR8n1","popZoom":"image_popZoom__Yx7mC","zoomable":"image_zoomable__jG8wo"};